import React, { ReactElement } from 'react';
import { PlanTitles } from 'models/DiversifiedPlanGroup';

interface Props {
    plans: string[];
    selectedPlan: string;
    onSelect: (planName: string) => void;
}
function DiversifiedGoalToggle({
  plans,
  selectedPlan,
  onSelect,
}:Props): ReactElement {
  return (
    <>
      <div
        className="c-plan__servings"
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >

        <fieldset style={{ width: 'auto', display: 'inline-block' }}>
          <ul
            role="radiogroup"
            className={[
              'c-switch',
            ].join(' ')}
            aria-labelledby="plan-servings"
          >
            {plans.map((plan) => (
              <li key={`${plan}_order_summary_btn`}>
                <button
                  id={`${plan}_order_summary_btn`}
                  type="button"
                  role="radio"
                  aria-label={`Select ${plan}`}
                  aria-checked="true"
                  className={(selectedPlan === plan || (selectedPlan === 'four_servings' && plan === 'chefs_choice'))
                    ? 'is-selected'
                    : ''}
                  onClick={() => onSelect(plan)}
                >
                  {PlanTitles[plan]}
                  <span className="sr-only">serving</span>
                </button>
              </li>
            ))}
          </ul>
        </fieldset>
      </div>
    </>
  );
}

export default DiversifiedGoalToggle;
